import {
  SearchFilterCondition,
  SearchFilterConditionDate,
} from 'lib-search-types';

import { ConditionFieldProps } from '../../conditionField';

import { ConditionFieldDateRange } from './components/conditionFieldDateRange';
import { ConditionFieldDateSingle } from './components/conditionFieldDateSingle';

export type ConditionFieldDateProps = ConditionFieldProps<
  Extract<
    SearchFilterCondition<'conversations'>,
    SearchFilterConditionDate<string>
  >
>;

/**
 * Represents a component that can be used to visualize a date or a date range
 * filter
 */
export const ConditionFieldDate = (
  props: ConditionFieldDateProps,
): JSX.Element => {
  const { condition } = props;
  const isRange = condition.operator === 'between';

  if (isRange) {
    return <ConditionFieldDateRange {...props} />;
  }
  return <ConditionFieldDateSingle {...props} />;
};
